import React, {Component} from 'react';
import {Button, Form, Modal} from 'semantic-ui-react';
import DeliveryData from "../../data/DeliveryData";
import {showToast} from "../../actions/ToastAction";
import {connect} from "react-redux";
import DataService from "../../functions/DataService";
import localDB from "../../data/localDB";

class RepairServiceOrder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sale: props.sale,
            technical: props.technical,
            technical_id: props.technical ? props.technical.id:null,
            technical_error: false,
            open: false,
            sending: false,
            technicals: []
        };
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    componentWillMount() {
        DataService.get(`technicals`).then((data) =>{
            let technicals = []
            data.map(technical => technicals.push({key: technical.user.id, text: technical.user.full_name, value: technical.user.id}))
            this.setState({technicals})
        })
    }

    handleClose = () => {
        this.setState({open: false});
    };

    handleOpenModal  = () => {
        this.setState({open: true});
    };

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.technical_id === null) {
            this.setState({technical_error: true});
        }else {
            let data = {
                technical: this.state.technical_id
            };
            this.setState({loading: true});
            DataService.doAction(data,`repairs/${this.state.sale}/technical`, 'PATCH', (res) =>{
                if(res.update){
                    this.props.showToast({message: 'Técnico Actualizado!', type: 'success'});
                    this.setState({technical: res['data']['user']})
                    this.handleClose()
                }
                this.setState({loading_add:false})
            });
        }
    };


    render() {
        return (
            <React.Fragment>
                <Button
                    primary
                    icon='mobile alternate'
                    fluid
                    labelPosition='left'
                    content={this.state.technical ? `Técnico: ${this.state.technical.full_name}`: 'Sin Asignar Técnico'}
                    loading={this.state.saving}
                    disabled={this.state.saving}
                    style={{marginTop:'1em'}}
                    onClick={ () => this.handleOpenModal()}
                />

                <Modal size='tiny' dimmer='inverted' open={this.state.open} onClose={this.handleClose}>
                    <Modal.Header>Repartidor</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Select label='Técnico' options={this.state.technicals}
                                             name='technical_id'
                                             onChange={this.handleChange}
                                             value={this.state.technical_id} placeholder='Técnico'
                                             error={this.state.technical_error}/>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' loading={this.state.sending} disabled={this.state.sending} labelPosition='left'
                                onClick={this.handleSubmit} content={this.state.delivery ? 'Actualizar':'Agregar'}/>
                    </Modal.Actions>
                </Modal>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(data){
            dispatch(showToast(data))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(RepairServiceOrder)



// WEBPACK FOOTER //
// ./src/components/sale/RepairServiceOrder.js